import footer from './footer';
import main from './main';
import surgery from './surgery';
import pricing from './pricing';
import doctors from './doctors';
import sales from './sales';
import partners from './partners';
import news from './news';

export default {
    footer, main, surgery, pricing, doctors, sales, partners, news
}



// WEBPACK FOOTER //
// ./src/texts/czech/index.js